import React, { Fragment } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import CollectionTitle from "../../atoms/CollectionTitle";
import { RowSeparator } from "../../atoms/RowSeparator";
import { DfpComponent } from "../../ads/dfp-component";
import OtherStory from "./OtherStory";
import MainStory from "./MainStory";

import "./six-col-seven-stories.m.css";
export default function SixColumnSevenStories({
  config = {},
  collection,
  stories,
  displayRowSeparator = true,
  displayRowTitle = true,
  displayCookTime = false,
  displayAuthorName = false,
  displayServing = false,
  extraProp = "",
}) {
  const associatedMetadata = get(collection, ["associated-metadata"], {});

  const showColumnSeparator = associatedMetadata.show_column_separator || null;
  const showRowSeparator = (associatedMetadata.show_row_separator && displayRowSeparator) || null;
  const showRowTitle = (associatedMetadata.show_row_title && displayRowTitle) || null;
  const showTimeStamp = associatedMetadata.show_timestamp || null;
  const showReadTime = associatedMetadata.show_read_time || null;
  const showCookTime = associatedMetadata.show_cook_time_of_first_story || displayCookTime || null;
  const enableAuthorNameOfFirstStory = associatedMetadata.show_author_name_of_first_story || displayAuthorName || null;
  const enableServingsForFirstStory = associatedMetadata.show_servings_of_first_story || displayServing || null;
  const showSubheadlineForFirstStory = associatedMetadata.show_subheadline_of_first_story || null;
  const show_row_ad_unit_bottom = associatedMetadata.show_row_ad_unit_bottom || null;
  const midAd1 = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "mid_page_1"], {}));

  const rowAdBottom = show_row_ad_unit_bottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );

  const deviceType = useDeviceType();
  const isTablet = deviceType === "tablet";
  const isMobile = deviceType === "mobile";
  const sectionSlug = extraProp;
  if (!stories.length) return null;

  const [firstStory, ...otherStories] = stories;
  return (
    <div className="container row-component" styleName="top-component-wrapper">
      {showRowTitle && (
        <div styleName="collection-title-container">
          <CollectionTitle collection={collection} />
        </div>
      )}
      <div styleName="sixColSevenStories">
        <MainStory
          story={firstStory}
          showCookTime={showCookTime}
          showReadTime={showReadTime}
          showTimeStamp={showTimeStamp}
          enableServingsForFirstStory={enableServingsForFirstStory}
          enableAuthorNameOfFirstStory={enableAuthorNameOfFirstStory}
          showSubheadlineForFirstStory={showSubheadlineForFirstStory}
          sectionSlug={sectionSlug}
        />
        <div styleName="story-separator"></div>
        <DfpComponent adStyleName="six-col-seven-stories" id={midAd1?.id} />

        <div styleName={showColumnSeparator ? "otherStories-with-separator" : "otherStories-without-separator"}>
          {otherStories.map((story, index) => {
            return (
              <Fragment key={index}>
                <OtherStory
                  story={story}
                  showCookTime={showCookTime}
                  showReadTime={showReadTime}
                  showTimeStamp={showTimeStamp}
                  sectionSlug={sectionSlug}
                />
                {isTablet && index === 2 && !showColumnSeparator && <div styleName="separator"></div>}
                {isMobile && (index === 1 || index === 3) && !showColumnSeparator && <div styleName="separator"></div>}
                {index < otherStories.length - 1 && showColumnSeparator && <div styleName="separator"></div>}
              </Fragment>
            );
          })}
        </div>
      </div>
      {showRowSeparator && <RowSeparator />}
      {show_row_ad_unit_bottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </div>
  );
}

SixColumnSevenStories.propTypes = {
  collection: PropTypes.shape({
    slug: PropTypes.string,
  }),
  stories: PropTypes.array.isRequired,
};

SixColumnSevenStories.storyLimit = 7;
